import clsx from "clsx";
// Components
import InputValue from "@/Layouts/components/InputComponents/InputValue";
// Types
import { TInputData } from "@/Layouts/types/InputComponents/InputFormExtension";
import { CSSProperties } from "react";
import { DataRecord } from "../types";
import { InputValueProps, NumberOrString } from "../InputValue/types";

const useDefaultValue = (data: TInputData[] = [], defaultType = "") => {
	if (defaultType) {
		return data.some((definition) => definition.type === defaultType && definition.defaultValue);
	}
	return false;
};

type InputFormExtensionProps = {
	data?: TInputData[];
	defaultType?: string;
	error?: boolean;
	isDefaultValueAllowed?: boolean;
	disabled?: boolean;
	related?: boolean;
	variant?: string;
	readOnly?: boolean;
	value: NumberOrString;
	onActionUpdate?: InputValueProps["onActionUpdate"];
	onChangeType?: InputValueProps["onChangeType"];
	sx?: CSSProperties;
};

export default function InputFormExtension(props: Readonly<InputFormExtensionProps>) {
	const { data, error, related = false, isDefaultValueAllowed, disabled, defaultType } = props;
	const defaultValue = useDefaultValue(data, defaultType);

	return (
		<InputValue
			{...props}
			data={data as DataRecord[]}
			defaultValue={defaultValue && isDefaultValueAllowed}
			related={related}
			variant={clsx({
				error,
				disabled: !error && disabled,
				default: !error && !disabled,
			})}
		/>
	);
}
